export default function Features() {
  const features = [
    {
      icon: 'ri-customer-service-2-line',
      title: 'Improve Customer Experience',
      description: 'Deliver exceptional service with AI agents that understand context and respond naturally to customer needs.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Increase Revenue',
      description: 'Convert more leads and close deals faster with AI-powered conversations that never miss an opportunity.'
    },
    {
      icon: 'ri-time-line',
      title: 'Unlock Time Savings',
      description: 'Free up your team from repetitive tasks and let them focus on high-value activities that grow your business.'
    },
    {
      icon: 'ri-global-line',
      title: 'Deploy Anywhere',
      description: 'Seamlessly integrate with your existing systems and deploy across multiple channels in any language.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Best-in-class TTFB',
      description: 'Lightning-fast response times ensure natural conversations without awkward pauses or delays.'
    },
    {
      icon: 'ri-robot-2-line',
      title: 'Advanced AI Technology',
      description: 'Powered by cutting-edge conversational AI that learns and adapts to your business needs.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose InstaVisible?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transform your business communication with AI agents that work 24/7 to drive results
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-100 hover:border-orange-200 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-orange-500 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl text-orange-500 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
